/*! @pentacode/ui v0.1.0 */
//#region src/elements/icon/sprite-source.ts
var e = "http://www.w3.org/2000/svg", t = /* @__PURE__ */ new Set(), n = "/icons/icons.svg", r = null, i = /* @__PURE__ */ new Set();
function a() {
	return n;
}
function o(e) {
	if (r) {
		if (r.ids.has(e)) return `${r.href}#${e}`;
		let t = e.endsWith(":active") ? e.slice(0, -7) : void 0;
		if (t && r.ids.has(t)) return `${r.href}#${t}`;
		i.has(e) || (i.add(e), console.warn(`icon sprite override has no ${e}, drawing the default`));
	}
	return `${n}#${e}`;
}
function s(e) {
	return t.add(e), () => t.delete(e);
}
function c() {
	for (let e of t) e();
}
async function l(e) {
	let t = await fetch(e, { mode: "cors" });
	if (!t.ok) throw Error(`icon sprite ${e.href}: ${t.status}`);
	return t.text();
}
function u(e) {
	return URL.createObjectURL(new Blob([e], { type: "image/svg+xml" }));
}
async function d(e) {
	let t = new URL(e, document.baseURI), r = n;
	n = t.origin === location.origin ? t.href : u(await l(t)), r.startsWith("blob:") && r !== n && URL.revokeObjectURL(r), c();
}
var f = Promise.resolve();
function p(e) {
	let t = f.then(() => m(e));
	return f = t.catch(() => {}), t;
}
async function m(t) {
	let n = null;
	if (t !== null) {
		let r = new URL(t, document.baseURI), i = await l(r), a = new DOMParser().parseFromString(i, "image/svg+xml");
		if (a.getElementsByTagName("parsererror").length) throw Error(`icon sprite ${r.href}: not valid svg`);
		if (a.documentElement.namespaceURI !== e) throw Error(`icon sprite ${r.href}: not an svg sprite`);
		let o = Array.from(a.getElementsByTagNameNS(e, "symbol")), s = new Set(o.filter((e) => e.id).map((e) => e.id));
		if (!s.size) throw Error(`icon sprite ${r.href}: no symbols`);
		n = {
			href: r.origin === location.origin ? r.href : u(i),
			ids: s
		};
	}
	r?.href.startsWith("blob:") && URL.revokeObjectURL(r.href), r = n, i.clear(), c();
}
//#endregion
export { o as iconHref, a as iconSpriteHref, s as onIconSpriteChange, p as setIconOverride, d as setIconSprite };

//# sourceMappingURL=sprite-source.js.map